import { DeleteStages } from 'constants/deleteStages';

import { useStagedDelete } from 'hooks/useStagedDelete';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { queryClient } from 'providers/queryClient';
import { useNotify } from 'react-admin';
import { CancelButton } from 'shared/mui/Buttons';
import { DeleteStageDialog } from 'shared/mui/Dialogs/DeleteStageDialog/DeleteStageDialog';
import { DeleteStageDialogDenyReason } from 'shared/mui/Dialogs/DeleteStageDialog/DeleteStageDialogDenyReason';
import { TypographyWithBold } from 'shared/mui/Typography';
import { GatewayRule } from 'types/embedded/gatewayRule';

type Props = {
  record?: GatewayRule;
  queryKey: string;
  open: boolean;
  onClose: () => void;
};

export const MerchantShowRulesDeleteDialog = ({ onClose, open, record, queryKey }: Props) => {
  const translate = useTypedTranslate();
  const notify = useNotify();

  const { deleteOneRecord, denyDeleteReason, stage, setStage } = useStagedDelete({
    record,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [queryKey] });
      setStage(DeleteStages.Initial);
      onClose();
      notify(
        <TypographyWithBold
          text={translate('app.merchants.ruleDeleted', { name: record?.name || '' })}
        />,
        { type: 'success' },
      );
    },
  });

  const handleCloseDeleteDialog = () => {
    setStage(DeleteStages.Initial);
    onClose();
  };

  return (
    <DeleteStageDialog
      deleteOneRecord={deleteOneRecord}
      details={translate('app.merchants.ruleWillBeDelete', { name: record?.name })}
      onClose={handleCloseDeleteDialog}
      open={open}
      stage={stage}
      title={translate('app.merchants.deleteRule')}
    >
      <DeleteStageDialogDenyReason reason={denyDeleteReason}>
        <CancelButton
          key="history-back-button"
          label={translate('app.buttons.close')}
          onClick={handleCloseDeleteDialog}
          variant="outlined"
        />
      </DeleteStageDialogDenyReason>
    </DeleteStageDialog>
  );
};
